module.exports = __webpack_public_path__ + "img/98a2e06848a6fe9b27c6a71cde847d31.2e5e574c.jpg";